module.exports = __webpack_public_path__ + "assets/58af3a31b173a244bddb5474c36e5334.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/5win.mp3
 ** module id = 205
 ** module chunks = 0
 **/